import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeriesPoint } from './op-chart-series-point'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'


export class OpGridColumn {
    //Properties
    public name: string
    public caption: OpDescr
    public typeName: string
    public idDataTypeFormat: number
    public tooltip: OpDescr
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.name = opObj.Name
            this.typeName = opObj.TypeName
            this.idDataTypeFormat = opObj.IdDataTypeFormat
            if (opObj.Caption)
                this.caption = new OpDescr(opObj.Caption)
            if (opObj.Tooltip)
                this.tooltip = new OpDescr(opObj.Tooltip)
        }
    }
}